import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { ZonarUIMaterialModule } from '@zonar-ui/material';

import { PAGE_URL } from '@src/app/constants/url.const';
import { CategoryContentComponent } from '@src/app/components/category-content/category-content.component';

@Component({
  selector: 'app-zone-editor',
  standalone: true,
  imports: [
    CommonModule,
    ZonarUIMaterialModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    CategoryContentComponent
  ],
  templateUrl: './zone-editor.component.html',
  styleUrls: ['./zone-editor.component.scss'],
})
export class ZoneEditorComponent {
  constructor(
    private router: Router,
  ) {}
  selectedTabIndex = 0;

  navigateToCreateZoneForm() {
    this.router.navigate([PAGE_URL.CREATE_ZONE_URL]);
  }
}